import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { SearchComponent } from './pages/search/search.component';
import { KeywordResultsComponent } from './pages/search/keyword-results/keyword-results.component';
import { SearchResultsComponent } from './pages/search/search-results/search-results.component';
import { AdvancedSearchComponent } from './pages/search/advanced-search/advanced-search.component';
import { ContactComponent } from './pages/contact/contact.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'about/:slug', component: AboutComponent },
  { path: 'about', redirectTo: 'about/about', pathMatch: 'full' },
  { path: 'contact', component: ContactComponent },
  { path: 'verify-email', component: VerifyEmailComponent },

  { path: 'search/advanced', component: AdvancedSearchComponent, data: { breadcrumb: 'Advanced Search' } },
  { path: 'search/results', component: SearchResultsComponent, data: { breadcrumb: 'Search Results' } },
  { path: 'search/:type', component: SearchComponent, data: { breadcrumb: 'Search' } },
  { path: 'keyword-search', component: KeywordResultsComponent, data: { breadcrumb: 'Keyword Search' } },

  // Legacy URL redirects for DOI registered URLs
  // Redirect old language-prefixed URLs to new structure
  { path: 'tr/book/:bookSlug/home', redirectTo: '/book/:bookSlug/home', pathMatch: 'full' },
  { path: 'en/book/:bookSlug/home', redirectTo: '/book/:bookSlug/home', pathMatch: 'full' },
  { path: 'de/book/:bookSlug/home', redirectTo: '/book/:bookSlug/home', pathMatch: 'full' },
  { path: 'ar/book/:bookSlug/home', redirectTo: '/book/:bookSlug/home', pathMatch: 'full' },
  { path: 'fr/book/:bookSlug/home', redirectTo: '/book/:bookSlug/home', pathMatch: 'full' },
  { path: 'tr/book/:bookSlug/chapter/:chapterSlug', redirectTo: '/book/:bookSlug/chapter/:chapterSlug', pathMatch: 'full' },
  { path: 'en/book/:bookSlug/chapter/:chapterSlug', redirectTo: '/book/:bookSlug/chapter/:chapterSlug', pathMatch: 'full' },
  { path: 'de/book/:bookSlug/chapter/:chapterSlug', redirectTo: '/book/:bookSlug/chapter/:chapterSlug', pathMatch: 'full' },
  { path: 'ar/book/:bookSlug/chapter/:chapterSlug', redirectTo: '/book/:bookSlug/chapter/:chapterSlug', pathMatch: 'full' },
  { path: 'fr/book/:bookSlug/chapter/:chapterSlug', redirectTo: '/book/:bookSlug/chapter/:chapterSlug', pathMatch: 'full' },
  { path: 'tr/book/:bookSlug', redirectTo: '/book/:bookSlug', pathMatch: 'full' },
  { path: 'en/book/:bookSlug', redirectTo: '/book/:bookSlug', pathMatch: 'full' },
  { path: 'de/book/:bookSlug', redirectTo: '/book/:bookSlug', pathMatch: 'full' },
  { path: 'ar/book/:bookSlug', redirectTo: '/book/:bookSlug', pathMatch: 'full' },
  { path: 'fr/book/:bookSlug', redirectTo: '/book/:bookSlug', pathMatch: 'full' },
  
  { path: 'tr/journal/:slug/home', redirectTo: '/journal/:slug/home', pathMatch: 'full' },
  { path: 'en/journal/:slug/home', redirectTo: '/journal/:slug/home', pathMatch: 'full' },
  { path: 'de/journal/:slug/home', redirectTo: '/journal/:slug/home', pathMatch: 'full' },
  { path: 'ar/journal/:slug/home', redirectTo: '/journal/:slug/home', pathMatch: 'full' },
  { path: 'fr/journal/:slug/home', redirectTo: '/journal/:slug/home', pathMatch: 'full' },
  { path: 'tr/journal/:slug/article/:articleSlug', redirectTo: '/journal/:slug/article/:articleSlug', pathMatch: 'full' },
  { path: 'en/journal/:slug/article/:articleSlug', redirectTo: '/journal/:slug/article/:articleSlug', pathMatch: 'full' },
  { path: 'de/journal/:slug/article/:articleSlug', redirectTo: '/journal/:slug/article/:articleSlug', pathMatch: 'full' },
  { path: 'ar/journal/:slug/article/:articleSlug', redirectTo: '/journal/:slug/article/:articleSlug', pathMatch: 'full' },
  { path: 'fr/journal/:slug/article/:articleSlug', redirectTo: '/journal/:slug/article/:articleSlug', pathMatch: 'full' },
  { path: 'tr/journal/:slug/issues', redirectTo: '/journal/:slug/issues', pathMatch: 'full' },
  { path: 'en/journal/:slug/issues', redirectTo: '/journal/:slug/issues', pathMatch: 'full' },
  { path: 'de/journal/:slug/issues', redirectTo: '/journal/:slug/issues', pathMatch: 'full' },
  { path: 'ar/journal/:slug/issues', redirectTo: '/journal/:slug/issues', pathMatch: 'full' },
  { path: 'fr/journal/:slug/issues', redirectTo: '/journal/:slug/issues', pathMatch: 'full' },
  { path: 'tr/journal/:slug/issue/:issueSlug', redirectTo: '/journal/:slug/issue/:issueSlug', pathMatch: 'full' },
  { path: 'en/journal/:slug/issue/:issueSlug', redirectTo: '/journal/:slug/issue/:issueSlug', pathMatch: 'full' },
  { path: 'de/journal/:slug/issue/:issueSlug', redirectTo: '/journal/:slug/issue/:issueSlug', pathMatch: 'full' },
  { path: 'ar/journal/:slug/issue/:issueSlug', redirectTo: '/journal/:slug/issue/:issueSlug', pathMatch: 'full' },
  { path: 'fr/journal/:slug/issue/:issueSlug', redirectTo: '/journal/:slug/issue/:issueSlug', pathMatch: 'full' },
  { path: 'tr/journal/:slug/information/:contentSlug', redirectTo: '/journal/:slug/information/:contentSlug', pathMatch: 'full' },
  { path: 'en/journal/:slug/information/:contentSlug', redirectTo: '/journal/:slug/information/:contentSlug', pathMatch: 'full' },
  { path: 'de/journal/:slug/information/:contentSlug', redirectTo: '/journal/:slug/information/:contentSlug', pathMatch: 'full' },
  { path: 'ar/journal/:slug/information/:contentSlug', redirectTo: '/journal/:slug/information/:contentSlug', pathMatch: 'full' },
  { path: 'fr/journal/:slug/information/:contentSlug', redirectTo: '/journal/:slug/information/:contentSlug', pathMatch: 'full' },
  { path: 'tr/journal/:slug/announcements/:announcementSlug', redirectTo: '/journal/:slug/announcements/:announcementSlug', pathMatch: 'full' },
  { path: 'en/journal/:slug/announcements/:announcementSlug', redirectTo: '/journal/:slug/announcements/:announcementSlug', pathMatch: 'full' },
  { path: 'de/journal/:slug/announcements/:announcementSlug', redirectTo: '/journal/:slug/announcements/:announcementSlug', pathMatch: 'full' },
  { path: 'ar/journal/:slug/announcements/:announcementSlug', redirectTo: '/journal/:slug/announcements/:announcementSlug', pathMatch: 'full' },
  { path: 'fr/journal/:slug/announcements/:announcementSlug', redirectTo: '/journal/:slug/announcements/:announcementSlug', pathMatch: 'full' },
  
  { path: 'tr/series/:seriesSlug/home', redirectTo: '/series/:seriesSlug/home', pathMatch: 'full' },
  { path: 'en/series/:seriesSlug/home', redirectTo: '/series/:seriesSlug/home', pathMatch: 'full' },
  { path: 'de/series/:seriesSlug/home', redirectTo: '/series/:seriesSlug/home', pathMatch: 'full' },
  { path: 'ar/series/:seriesSlug/home', redirectTo: '/series/:seriesSlug/home', pathMatch: 'full' },
  { path: 'fr/series/:seriesSlug/home', redirectTo: '/series/:seriesSlug/home', pathMatch: 'full' },
  { path: 'tr/series/:seriesSlug', redirectTo: '/series/:seriesSlug', pathMatch: 'full' },
  { path: 'en/series/:seriesSlug', redirectTo: '/series/:seriesSlug', pathMatch: 'full' },
  { path: 'de/series/:seriesSlug', redirectTo: '/series/:seriesSlug', pathMatch: 'full' },
  { path: 'ar/series/:seriesSlug', redirectTo: '/series/:seriesSlug', pathMatch: 'full' },
  { path: 'fr/series/:seriesSlug', redirectTo: '/series/:seriesSlug', pathMatch: 'full' },

  // Generic language prefix redirects for other paths
  { path: 'tr/about/:slug', redirectTo: '/about/:slug', pathMatch: 'full' },
  { path: 'en/about/:slug', redirectTo: '/about/:slug', pathMatch: 'full' },
  { path: 'de/about/:slug', redirectTo: '/about/:slug', pathMatch: 'full' },
  { path: 'ar/about/:slug', redirectTo: '/about/:slug', pathMatch: 'full' },
  { path: 'fr/about/:slug', redirectTo: '/about/:slug', pathMatch: 'full' },
  { path: 'tr/contact', redirectTo: '/contact', pathMatch: 'full' },
  { path: 'en/contact', redirectTo: '/contact', pathMatch: 'full' },
  { path: 'de/contact', redirectTo: '/contact', pathMatch: 'full' },
  { path: 'ar/contact', redirectTo: '/contact', pathMatch: 'full' },
  { path: 'fr/contact', redirectTo: '/contact', pathMatch: 'full' },
  { path: 'tr/home', redirectTo: '/home', pathMatch: 'full' },
  { path: 'en/home', redirectTo: '/home', pathMatch: 'full' },
  { path: 'de/home', redirectTo: '/home', pathMatch: 'full' },
  { path: 'ar/home', redirectTo: '/home', pathMatch: 'full' },
  { path: 'fr/home', redirectTo: '/home', pathMatch: 'full' },
  { path: 'tr/p/:slug', redirectTo: '/p/:slug', pathMatch: 'full' },
  { path: 'en/p/:slug', redirectTo: '/p/:slug', pathMatch: 'full' },
  { path: 'de/p/:slug', redirectTo: '/p/:slug', pathMatch: 'full' },
  { path: 'ar/p/:slug', redirectTo: '/p/:slug', pathMatch: 'full' },
  { path: 'fr/p/:slug', redirectTo: '/p/:slug', pathMatch: 'full' },
  { path: 'tr/search/:type', redirectTo: '/search/:type', pathMatch: 'full' },
  { path: 'en/search/:type', redirectTo: '/search/:type', pathMatch: 'full' },
  { path: 'de/search/:type', redirectTo: '/search/:type', pathMatch: 'full' },
  { path: 'ar/search/:type', redirectTo: '/search/:type', pathMatch: 'full' },
  { path: 'fr/search/:type', redirectTo: '/search/:type', pathMatch: 'full' },
  { path: 'tr', redirectTo: '/', pathMatch: 'full' },
  { path: 'en', redirectTo: '/', pathMatch: 'full' },
  { path: 'de', redirectTo: '/', pathMatch: 'full' },
  { path: 'ar', redirectTo: '/', pathMatch: 'full' },
  { path: 'fr', redirectTo: '/', pathMatch: 'full' },

  // Slug change redirects: old journal slug "jarhs" -> new slug "iujhsr"
  // Keeps already-registered DOI URLs working after the slug change.
  // (Language-prefixed old DOIs first hit the tr|en|de|ar|fr rules above -> /journal/jarhs/... -> chained here.)
  { path: 'journal/jarhs/home', redirectTo: '/journal/iujhsr/home', pathMatch: 'full' },
  { path: 'journal/jarhs/article/:articleSlug', redirectTo: '/journal/iujhsr/article/:articleSlug', pathMatch: 'full' },
  { path: 'journal/jarhs/issues', redirectTo: '/journal/iujhsr/issues', pathMatch: 'full' },
  { path: 'journal/jarhs/issue/:issueSlug', redirectTo: '/journal/iujhsr/issue/:issueSlug', pathMatch: 'full' },
  { path: 'journal/jarhs/information/:contentSlug', redirectTo: '/journal/iujhsr/information/:contentSlug', pathMatch: 'full' },
  { path: 'journal/jarhs/announcements/:announcementSlug', redirectTo: '/journal/iujhsr/announcements/:announcementSlug', pathMatch: 'full' },
  { path: 'journal/jarhs', redirectTo: '/journal/iujhsr', pathMatch: 'full' },

  {
    path: 'journal',
    loadChildren: () => import('./pages/journal/journal.module').then(m => m.JournalModule)
  },

  { 
    path: 'series', 
    loadChildren: () => import('./pages/series/series.module').then(m => m.SeriesModule)
  },

  
  { 
    path: 'book', 
    loadChildren: () => import('./pages/book/book.module').then(m => m.BookModule)
  },

  { path: 'p/:slug', loadChildren: () => import('./pages/person/person.module').then(m => m.PersonModule) },

  // Redirect author URLs to person profile
  { path: 'author/:slug', redirectTo: '/p/:slug', pathMatch: 'full' },

  { path: '**', redirectTo: '' } // Wildcard route for 404
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }